<template>
  <base-card custom>
    <base-heading class="pl-3 pt-2 title-card">
      Outreach
    </base-heading>
    <outreach-list-container
      class="mt-n2"
      :page-size="pageSize"
      :manager-scope="true"
      :events-percentage="false"
      :unique-events="false"
      empty-title="No reports yet"
      empty-subtitle="Data will appear as your Team Members send edits to their Clients."
    />
    <!-- :filter="{period: dataRange}" -->
  </base-card>
</template>
<script>
import OutreachListContainer from '@/components/Widgets/OutreachListContainer';

export default {

  name: 'AdminTopInformation',
  components: {
    OutreachListContainer,
  },
  props: {
    linksClicked: {
      type: Array,
      default: () => [],
    },
    linksClickedLoading: {
      type: Boolean,
      default: false,
    },
    deviceOpens: {
      type: Array,
      default: () => [],
    },
    deviceOpensLoading: {
      type: Boolean,
      default: false,
    },
    dataRange: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      pageSize: 10,
      fakeloading: false,
    };
  },
  // computed: {
  //   periodFilter() {
  //     if (!this.periods || !this.periods.length)
  //       return {}
  //     const thisPeriodName = this.periods[this.current].toLowerCase()
  //     return {
  //       period: thisPeriodName.includes('week') ? 'week' : thisPeriodName.includes('month') ? 'month' : 'year'
  //     }
  //   }
  // },
};
</script>
<style lang="css"
  scoped>
.links-and-devices {
  background-color: rgba(233, 173, 125, 0.3);
  ;
}
::v-deep .base-heading{
  margin-bottom: 5px !important;
}
::v-deep .my-2{
    display: none;
}
.title-card {
  font-family: 'Tiempos Headline';
  font-weight: 600;
  font-size: 23px;
  line-height: 120%;
  letter-spacing: 0.01em;
  color: #1B1B1B;
  margin-bottom: unset;
}
</style>
